module.exports = __webpack_public_path__ + "img/22.0b74ed7c.png";